import { render } from "./TransportCourier.vue?vue&type=template&id=dc3e8cce"
import script from "./TransportCourier.vue?vue&type=script&lang=js"
export * from "./TransportCourier.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__